import React from 'react';
import styled from 'styled-components';
import { sectionMargins } from '../styles';
import { Container, Video } from './ui';

const StyledInternalVideo = styled.section`
  ${({ isBlogSingle }) =>
    isBlogSingle ? sectionMargins('30px', '50px') : sectionMargins()}
`;

const InternalVideo = ({ video, isBlogSingle }) => (
  <StyledInternalVideo isBlogSingle={isBlogSingle}>
    <Container narrow={isBlogSingle}>
      <Video data={video} />
    </Container>
  </StyledInternalVideo>
);

export default InternalVideo;
